const yyyymmdd = (date: string) => {
  return new Date(date).toLocaleDateString('fr-CA');
};

const mmddyyyy = (date: string) => {
  return new Date(date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

const mmyyyy = (date: string) => {
  return new Date(date).toLocaleDateString(undefined, {
    year: 'numeric',
    month: '2-digit',
  });
};

const formatDate = {
  yyyymmdd,
  mmddyyyy,
  mmyyyy,
};

export default formatDate;
